(() => {
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-cadeau-builder]').forEach((root) => {
      if (root.dataset.cadeauReady === 'true') return;
      root.dataset.cadeauReady = 'true';

      const sizeButtons = [...root.querySelectorAll('[data-cadeau-size]')];
      const filterButtons = [...root.querySelectorAll('[data-cadeau-filter]')];
      const cards = [...root.querySelectorAll('[data-cadeau-item]')];
      const selectionList = root.querySelector('[data-cadeau-selection]');
      const selectionEmpty = root.querySelector('[data-cadeau-empty]');
      const boxTitle = root.querySelector('[data-cadeau-box-title]');
      const boxPrice = root.querySelector('[data-cadeau-box-price]');
      const spaceUsed = root.querySelector('[data-cadeau-space-used]');
      const spaceTotal = root.querySelector('[data-cadeau-space-total]');
      const meter = root.querySelector('[data-cadeau-meter]');
      const total = root.querySelector('[data-cadeau-total]');
      const submit = root.querySelector('[data-cadeau-submit]');
      const submitLabel = submit?.querySelector('span');
      const status = root.querySelector('[data-cadeau-status]');
      const cartLink = root.querySelector('[data-cadeau-cart]');
      const helpLink = root.querySelector('[data-cadeau-help]');
      const recipient = root.querySelector('[data-cadeau-recipient]');
      const message = root.querySelector('[data-cadeau-message]');
      const messageCount = root.querySelector('[data-cadeau-message-count]');
      const minimumItems = Number(root.dataset.minimumItems || 1);

      const locale = document.documentElement.lang || 'it-IT';
      const currency = root.dataset.currency || 'EUR';
      const money = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });

      const items = cards.map((card, index) => ({
        key: String(index),
        card,
        variantId: card.dataset.variantId,
        title: card.dataset.title,
        price: Number(card.dataset.price || 0),
        category: card.dataset.category,
        categoryLabel: card.querySelector('.cadeau-item__category')?.textContent.trim() || '',
        sizes: card.dataset.sizes,
        space: Number(card.dataset.space || 1),
        available: card.dataset.available === 'true'
      }));

      const state = {
        size: '',
        filter: 'all',
        selected: new Map(),
        busy: false
      };

      const currentBox = () => sizeButtons.find((button) => button.dataset.cadeauSize === state.size);
      const quantityFor = (item) => state.selected.get(item.key) || 0;
      const selectedEntries = () => items.filter((item) => quantityFor(item) > 0);
      const selectedQuantity = () => selectedEntries().reduce((sum, item) => sum + quantityFor(item), 0);
      const usedCapacity = () => selectedEntries().reduce((sum, item) => sum + (quantityFor(item) * item.space), 0);
      const bottleQuantity = () => selectedEntries().reduce((sum, item) => sum + (item.category === 'wine' ? quantityFor(item) : 0), 0);
      const eligibleForSize = (item) => item.sizes === 'both' || item.sizes === state.size;

      const setStatus = (text = '', isError = false) => {
        status.textContent = text;
        status.classList.toggle('is-error', isError);
      };

      const resetSuccess = () => {
        cartLink.hidden = true;
        if (submitLabel) submitLabel.textContent = root.dataset.addLabel;
      };

      const changeQuantity = (item, direction) => {
        if (state.busy || !item.available) return;
        const current = quantityFor(item);

        if (direction > 0) {
          const box = currentBox();
          const capacity = Number(box?.dataset.capacity || 0);
          const bottleLimit = Number(box?.dataset.bottleLimit || 1);
          if (usedCapacity() + item.space > capacity) {
            setStatus(root.dataset.errorCapacity, true);
            return;
          }
          if (item.category === 'wine' && bottleQuantity() + 1 > bottleLimit) {
            setStatus(root.dataset.errorBottle, true);
            return;
          }
          state.selected.set(item.key, current + 1);
        } else if (current > 1) {
          state.selected.set(item.key, current - 1);
        } else {
          state.selected.delete(item.key);
        }

        setStatus();
        resetSuccess();
        render();
      };

      const renderCards = () => {
        items.forEach((item) => {
          const quantity = quantityFor(item);
          const matchesFilter = state.filter === 'all' || item.category === state.filter;
          item.card.hidden = !eligibleForSize(item) || !matchesFilter;
          item.card.classList.toggle('is-selected', quantity > 0);
          const quantityLabel = item.card.querySelector('[data-cadeau-quantity]');
          const minus = item.card.querySelector('[data-cadeau-minus]');
          if (quantityLabel) quantityLabel.textContent = quantity;
          if (minus) minus.disabled = quantity === 0;
        });

        filterButtons.forEach((button) => {
          const category = button.dataset.cadeauFilter;
          const hasEligibleItems = category === 'all' || items.some((item) => item.category === category && eligibleForSize(item));
          button.hidden = !hasEligibleItems;
          const active = category === state.filter;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      };

      const createSummaryItem = (item) => {
        const row = document.createElement('li');
        const copy = document.createElement('div');
        const title = document.createElement('b');
        const detail = document.createElement('small');
        const controls = document.createElement('div');
        const minus = document.createElement('button');
        const quantity = document.createElement('span');
        const plus = document.createElement('button');

        copy.className = 'cadeau-summary__item-copy';
        controls.className = 'cadeau-summary__item-controls';
        title.textContent = item.title;
        detail.textContent = item.categoryLabel + ' · ' + money.format(item.price / 100);
        minus.type = 'button';
        minus.textContent = '−';
        minus.setAttribute('aria-label', '− ' + item.title);
        plus.type = 'button';
        plus.textContent = '+';
        plus.setAttribute('aria-label', '+ ' + item.title);
        quantity.textContent = quantityFor(item);
        minus.addEventListener('click', () => changeQuantity(item, -1));
        plus.addEventListener('click', () => changeQuantity(item, 1));

        copy.append(title, detail);
        controls.append(minus, quantity, plus);
        row.append(copy, controls);
        return row;
      };

      const renderSummary = () => {
        const box = currentBox();
        const capacity = Number(box?.dataset.capacity || 0);
        const used = usedCapacity();
        const boxAmount = Number(box?.dataset.price || 0);
        const itemsAmount = selectedEntries().reduce((sum, item) => sum + (item.price * quantityFor(item)), 0);
        const hasBox = Boolean(box?.dataset.variantId);

        boxTitle.textContent = box?.dataset.title || '—';
        boxPrice.textContent = hasBox ? money.format(boxAmount / 100) : '—';
        spaceUsed.textContent = used;
        spaceTotal.textContent = capacity;
        meter.style.transform = 'scaleX(' + Math.min(1, capacity ? used / capacity : 0) + ')';
        total.textContent = hasBox ? money.format((boxAmount + itemsAmount) / 100) : '—';

        selectionList.replaceChildren();
        const entries = selectedEntries();
        selectionEmpty.hidden = entries.length > 0;
        entries.forEach((item) => selectionList.append(createSummaryItem(item)));

        const boxReady = hasBox && box.dataset.available === 'true';
        const enoughItems = selectedQuantity() >= minimumItems;
        submit.disabled = state.busy;
        submit.classList.toggle('is-incomplete', !boxReady || !enoughItems);
        if (helpLink) helpLink.hidden = boxReady;
      };

      function render() {
        renderCards();
        renderSummary();
      }

      const selectSize = (size, announce = true) => {
        if (state.size === size) return;
        const hadSelection = state.selected.size > 0;
        state.size = size;
        state.selected.clear();

        sizeButtons.forEach((button) => {
          const active = button.dataset.cadeauSize === size;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        const activeFilterHasItems = state.filter === 'all' || items.some((item) => item.category === state.filter && eligibleForSize(item));
        if (!activeFilterHasItems) state.filter = 'all';
        resetSuccess();
        if (announce && hadSelection) setStatus(root.dataset.sizeChanged);
        else setStatus();
        render();
      };

      sizeButtons.forEach((button) => {
        button.addEventListener('click', () => selectSize(button.dataset.cadeauSize));
      });

      filterButtons.forEach((button) => {
        button.addEventListener('click', () => {
          state.filter = button.dataset.cadeauFilter;
          renderCards();
        });
      });

      items.forEach((item) => {
        item.card.querySelector('[data-cadeau-add]')?.addEventListener('click', () => changeQuantity(item, 1));
        item.card.querySelector('[data-cadeau-minus]')?.addEventListener('click', () => changeQuantity(item, -1));
      });

      message?.addEventListener('input', () => {
        messageCount.textContent = message.value.length;
      });

      submit?.addEventListener('click', async () => {
        const box = currentBox();
        if (!box?.dataset.variantId || box.dataset.available !== 'true') {
          setStatus(root.dataset.errorBox, true);
          return;
        }
        if (selectedQuantity() < minimumItems) {
          setStatus(root.dataset.errorItems, true);
          return;
        }

        const compositionId = 'ECLAT-' + Date.now().toString(36).toUpperCase();
        const properties = {
          'Formato cadeau': box.dataset.title,
          '_Cadeau ID': compositionId
        };
        if (recipient?.value.trim()) properties.Destinatario = recipient.value.trim();
        if (message?.value.trim()) properties.Messaggio = message.value.trim();

        const cartItems = [{
          id: Number(box.dataset.variantId),
          quantity: 1,
          properties
        }];
        selectedEntries().forEach((item) => {
          cartItems.push({
            id: Number(item.variantId),
            quantity: quantityFor(item),
            properties: {
              '_Cadeau ID': compositionId,
              '_Parte di': box.dataset.title
            }
          });
        });

        state.busy = true;
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        if (submitLabel) submitLabel.textContent = root.dataset.addingLabel;
        setStatus();

        try {
          const shopRoot = window.Shopify?.routes?.root || '/';
          const base = shopRoot.endsWith('/') ? shopRoot : shopRoot + '/';
          const response = await fetch(base + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items: cartItems })
          });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.description || root.dataset.errorGeneric);

          const cart = await fetch(base + 'cart.js').then((cartResponse) => cartResponse.json());
          document.querySelectorAll('[data-cart-count]').forEach((node) => {
            node.textContent = cart.item_count;
          });
          if (submitLabel) submitLabel.textContent = root.dataset.addedLabel;
          cartLink.hidden = false;
          setStatus(root.dataset.addedLabel);
        } catch (error) {
          setStatus(error.message || root.dataset.errorGeneric, true);
          if (submitLabel) submitLabel.textContent = root.dataset.addLabel;
        } finally {
          state.busy = false;
          submit.removeAttribute('aria-busy');
          renderSummary();
        }
      });

      selectSize(sizeButtons[0]?.dataset.cadeauSize || 'small', false);
    });
  };

  if (!window.EclatCadeauBuilderInit) {
    window.EclatCadeauBuilderInit = initialise;
    document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  }
  initialise();
})();
